import { heroCopy } from '@/mocks/hero';

export function ScrollCue() {
  return (
    <div className="wp-ui-fade wp-cue absolute bottom-8 left-1/2 z-30 -translate-x-1/2 flex flex-col items-center gap-3 text-background-200/80">
      <span className="text-[11px] uppercase tracking-[0.24em] whitespace-nowrap">{heroCopy.scrollHint}</span>
      <span className="block h-10 w-px bg-gradient-to-b from-background-200/80 to-transparent" />
    </div>
  );
}

export default function HeroContent() {
  return (
    <div className="wp-content absolute inset-0 z-20 flex items-center px-4 md:px-10">
      <div className="relative mx-auto w-full max-w-2xl text-center" style={{ perspective: '900px' }}>
        <p className="wp-reveal mb-4 text-[11px] uppercase tracking-[0.24em] text-accent-200">{heroCopy.eyebrow}</p>
        <h1 className="wp-reveal font-heading text-4xl md:text-6xl font-light leading-[1.05] tracking-tight text-background-50">{heroCopy.headline}</h1>
        <p className="wp-reveal mx-auto mt-5 max-w-md text-sm md:text-base leading-relaxed text-background-100/90">{heroCopy.copy}</p>
        <a href={heroCopy.ctaHref} className="wp-reveal mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors cursor-pointer">
          {heroCopy.cta}
          <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line" /></span>
        </a>
      </div>
    </div>
  );
}